export default __webpack_public_path__ + "static/media/EditIcon.5b2ac65e.svg";